import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface StorageState {
  guestSeq: number
  carnum: string
  isBannerClosed: boolean
  isAirportBannerClosed: boolean
  setGuestSeq: (guestSeq: number) => void
  setCarnum: (carnum: string) => void
  setIsBannerClosed: (isBannerClosed: boolean) => void
  setIsAirportBannerClosed: (isAirportBannerClosed: boolean) => void
}

//NOTE: sessionStorage clear시 useStorageStore.persist.clear(name?) 호출 필요
export const useStorageStore = create<StorageState>()(
  persist(
    (set) => ({
      guestSeq: 0,
      carnum: '',
      isBannerClosed: false,
      isAirportBannerClosed: false,
      setGuestSeq: (guestSeq) => set({ guestSeq }),
      setCarnum: (carnum) => set({ carnum }),
      setIsBannerClosed: (isBannerClosed) => set({ isBannerClosed }),
      setIsAirportBannerClosed: (isAirportBannerClosed) => set({ isAirportBannerClosed })
    }),
    {
      name: 'user-storage',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
